/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { findById as legacy_findById } from 'core/utils/legacyUtils';

class ExamQuestionMultipleChoiceList extends Component {
  render() {
    const answerSolutions = this.props.answerSolutions;
    const response = this.props.response;
    const isReviewingMistake = this.props.isReviewingMistake;

    const renderedAnswers = this.props.answers.map((answer, i) => {
      let text;
      text = <div dangerouslySetInnerHTML={{ __html: answer.text }} />;

      const classes = [];

      let isCorrect = false;
      if (answerSolutions) {
        isCorrect =
          legacy_findById(answerSolutions, answer.id)?.is_correct || false;
        if (isCorrect) {
          classes.push('correct');
        }
      }

      // Indicate the actual response (incorrect) if a response is provided
      if (response) {
        const selectedAnswer = parseInt(response.select_selected_answer, 10);
        if (
          isReviewingMistake &&
          !_.isUndefined(response) &&
          selectedAnswer === answer.id
        ) {
          if (!isCorrect) {
            classes.push('incorrect');
          }
        }
      }

      return (
        <li className={classNames(classes)} key={i}>
          {text}
        </li>
      );
    });

    return (
      <ol type="A" className="multiple-choice-answers">
        {renderedAnswers}
      </ol>
    );
  }
}

export default ExamQuestionMultipleChoiceList;
